export default function Hamburguer() {
    return (
        <span className="flex justify-center items-center w-[26px] h-[24px] rounded-[3px] cursor-pointer bg-darker lg:hidden">
            <img
                src="/assets/icons/hamburger-menu.svg"
                alt="Menu icon"
                className="w-[24px] h-[24px] cursor-pointer"
            />
        </span>
    );
}